import React from 'react';
import {
    AiOutlinePaperClip,
    AiOutlineCheck,
    AiOutlineDelete,
    AiOutlineCloudDownload 
} from 'react-icons/ai';
import Swal from 'sweetalert2';

import { getDownloadURLAPI, deleteFile, singleFileUploader } from '../../utils/FirebaseStorage/FirebaseStorage';



let AttachCardV2 = (props) => {
    const downloadFile = async (file) => {
        try {
            let downloadLink = await getDownloadURLAPI(`APEFiles/${props.apeId}`, file.fileName)
            let downloadWindow = window.open(downloadLink, "_blank", "noopener,noreferrer")
            if (downloadWindow) downloadWindow.opener = null
            // toastSuccess('Descarga Exitosa!')
        }
        catch (e) {
            // toastError('Hubo un problema con la descarga!')
            console.log('error', e)
        }
    }

    const delFile = async (file) => {
        props.setLoading(true);
        let tempFileList = props.fileList
        try {
            await deleteFile(`APEFiles/${props.apeId}`, file.fileName);
            const fileIndex = props.fileList.indexOf(file);
            tempFileList.splice(fileIndex, 1);
            props.setFileList(tempFileList);
            Swal.fire({
                title: "Archivo Eliminado!",
                text: "El archivo ha sido eliminado con exito!",
                icon: "success"
            });
            props.setLoading(false);
        }
        catch (e) {
            props.setLoading(false);
            console.log('error', e)
        }
    }

    const uploadFile = async (file) => {
        console.log('file', file);
        console.log('file URL', `APEFiles/${props.apeId}`);
        console.log('file NAME', `${file.key}${file.name.substring(file.name.lastIndexOf('.'))}`);
        props.setLoading(true);
        try {
            let tempFilesList = props.fileList
            const newFile = await singleFileUploader(file, `APEFiles/${props.apeId}`, `${file.key}${file.name.substring(file.name.lastIndexOf('.'))}`);
            console.log('newFile', newFile);
            tempFilesList.push({ fileName: newFile[0].name })
            props.setFileList(tempFilesList)
            Swal.fire({
                title: "Archivo Cargado!",
                text: "El archivo ha sido cargado con exito!",
                icon: "success"
            });
            props.setLoading(false);
        }
        catch (e) {
            props.setLoading(false);
            console.log('error', e)
        }
    }

    const handleFile = (file) => {
        const tempFile = file;
        tempFile['key']=props.id;
        return tempFile
    }
    return (
        <div className='attach-card'>
            <div className='attach-card-content'>
                <input key={`input_${props.id}`} type="file" id={`uploadAssetsInput_${props.id ?? 'test'}`} onChange={(e) => { uploadFile(handleFile(e.target.files[0])) }} style={{ display: 'none' }} />
                {/* <input type="file" id='uploadAssetsInput' onChange={(e) => { console.log(e.target.files[0]) }} style={{ display: 'none' }} /> */}
                {props.attached ?
                    <div className='attach-card-content-icons'>
                        <div className='attach-card-content-icon' style={{ fontSize: 20 }} onClick={async () => { await downloadFile(props.file); }}><AiOutlineCloudDownload /></div>
                        <div className='attach-card-content-icon' style={{ fontSize: 20 }} onClick={async () => { await delFile(props.file) }}><AiOutlineDelete /></div>
                    </div> :
                    <div className='attach-card-content-icons'>
                        <div className='attach-card-content-icon' style={{ fontSize: 20 }} onClick={() => { document.getElementById(`uploadAssetsInput_${props.id ?? 'test'}`).click() }}><AiOutlinePaperClip /></div>

                    </div>}
                <div className={'attach-card-text'} style={{ fontSize: 12, textAlign: 'center' }}>{props.file ? props.file.fileName : props.subText}</div>

            </div>
        </div>
    )
    ;
}
export default AttachCardV2;